import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Logo } from "@/components/Logo";

export function MobileMenu({ openAuth }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const item = "block rounded-xl px-4 py-3 text-base font-semibold hover:bg-surface transition-colors";
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button type="button" aria-label="Open menu" data-testid="mobile-menu-btn" className="md:hidden h-10 w-10 inline-flex items-center justify-center rounded-full border border-border bg-background">
          <Menu className="h-5 w-5" />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[85vw] max-w-sm bg-background" data-testid="mobile-menu-panel">
        <SheetHeader><SheetTitle className="sr-only">Menu</SheetTitle><Logo size="sm" /></SheetHeader>
        <nav className="mt-8 space-y-1">
          <button type="button" onClick={() => { close(); openAuth(); }} data-testid="mobile-menu-post-campaign" className={`${item} w-full text-left text-brand-pink`}>Post a Campaign</button>
          <Link to="/influencer-directory" onClick={close} data-testid="mobile-menu-find-influencers" className={item}>Find Influencers</Link>
          <a href="#how" onClick={close} data-testid="mobile-menu-how" className={item}>How it works</a>
          <a href="#features" onClick={close} data-testid="mobile-menu-features" className={item}>Features</a>
        </nav>
        <button type="button" onClick={() => { close(); openAuth(); }} data-testid="mobile-menu-signin" className="mt-8 w-full rounded-full bg-neon-lime text-background py-3 font-semibold">Sign in / Sign up</button>
      </SheetContent>
    </Sheet>
  );
}
